<template>
  <div class="m-container">
    <m_header></m_header>
    <m_menu></m_menu>
    <div class="m-body">
      <el-container class="m-title-box">
        <div class="m-title">
          <div class="m-title-t">用户发票信息</div>
          <span class="m-title-s">对用户开发票情况管理等操作</span>
        </div>
        <div class="m-tips">
          <i class="el-icon-warning"></i>使用提示
        </div>
      </el-container>
      <div class="m-search-wrap">
        <el-form :inline="true" :model="searchForm" ref="searchForm">
            <el-form-item label="用户电话:">
              <el-input type="text" size="medium" v-model="searchForm.phone"  placeholder="搜索用户电话" />
            </el-form-item>
          <el-form-item style="margin-left: 30px;">
            <el-button type="primary" @click="search()">搜索</el-button>
            <el-button type="primary" plain @click="resetForm()">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="m-table">
        <el-container class="m-table-head">
          <div class="m-table-title">
            <i class="el-icon-s-opportunity"></i>发票列表
          </div>
          <div class="m-table-btn">
            <!--<el-button @click="openPopup" type="primary" size="">备用</el-button>-->
          </div>
        </el-container>
        <el-table :data="list" v-loading="isLoading" style="width: 100%;margin-bottom: 20px;" border size="mini">
          <el-table-column prop="phone" label="电话" width="130" align="center"></el-table-column>
          <el-table-column prop="gfmc" label="购方名称(抬头)" width=""></el-table-column>
          <el-table-column prop="gfsh" label="购方税号" width=""></el-table-column>
          <el-table-column prop="je" label="发票金额" width=""></el-table-column>
          <el-table-column prop="mail" label="接收邮箱" width="" align="center"></el-table-column>
          <el-table-column prop="createDate" label="创建时间" width="" align="center"></el-table-column>
<!--          <el-table-column label="操作" width="120" align="center">-->
<!--            <template slot-scope="scope">-->
<!--              <el-button type="primary" size="mini" @click="openForm(scope.row.id)" plain>详细资料</el-button>-->
<!--            </template>-->
<!--          </el-table-column>-->
        </el-table>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="searchForm.pageNo"
          :page-size="10"
          layout="total, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="详细信息" :visible.sync="openState" @close='closeDialog' width="950px" :close-on-click-modal="false">
      <div v-loading="formLoading" class="m-user-open">
        <div class="m-user-open-item">
          <label>用户昵称：</label>
          <div class="m-user-open-cont">{{form.nickname}}</div>
        </div>
        <div class="m-user-open-item">
          <label>手机号：</label>
          <div class="m-user-open-cont" style="font-weight: bold;">{{form.phone}}</div>
        </div>
        <div class="m-user-open-item">
          <label>用户性别：</label>
          <div v-text="form.sex === '1' ? '男' : '女'" class="m-user-open-cont"></div>
        </div>
        <div class="m-user-open-item">
          <label>用户职业：</label>
          <div class="m-user-open-cont">{{form.occupation}}</div>
        </div>
        <div class="m-user-open-item">
          <label>用户生日：</label>
          <div class="m-user-open-cont">{{form.birthday}}</div>
        </div>
        <div class="m-user-open-item">
          <label>学习目标：</label>
          <div class="m-user-open-cont">{{form.target}}</div>
        </div>
        <div class="m-user-open-item">
          <label>所属地区：</label>
          <div class="m-user-open-cont">{{form.cityName}}</div>
        </div>
        <div class="m-user-open-item">
          <label>所属服务商：</label>
          <div class="m-user-open-cont">{{form.cooperatorName}}</div>
        </div>
        <div class="m-user-open-item" style="width: 100%;">
          <label>详细地址：</label>
          <div class="m-user-open-cont">{{form.address}}</div>
        </div>
      </div>
      <div slot="footer" class="dialog-foote" style="text-align: center;">
        <el-button @click="openState = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'userInvoice',
  data () {
    return {
      openState: false,
      formLoading: false,
      isLoading: true,
      isStatus: true,
      list: [],
      coopList: [],
      total: 0,
      form: {
        id: '',
        userId: '',
        phone: '',
        cooperatorId: '',
        userIcon: '',
        cityName: '',
        nickname: '',
        sex: '',
        birthday: '',
        address: '',
        occupation: '',
        target: '',
        dream: '',
        qrCodePath: '',
        shareUserId: '',
        loginIp: '',
        loginDate: '',
        createDate: '',
        updateDate: ''
      },
      searchForm: {
        phone: '',
        pageNo: 1
      },
      searchPattern: [
        {
          size: 'medium',
          placeholder: '--选择省份--',
          isDisabled: false
        }, {
          size: 'medium',
          placeholder: '--选择城市--',
          isDisabled: false
        }, {
          size: 'medium',
          placeholder: '--选择区县--',
          isDisabled: false
        }
      ]
    }
  },
  methods: {
    handleCurrentChange (val) {
      this.searchForm.pageNo = val
      this.listData()
    },
    search () {
      this.searchForm.pageNo = 1
      this.listData()
    },
    resetForm () {
      this.searchForm = {
        phone: '',
        pageNo: 1
      }
      this.listData()
    },
    closeDialog () {
      this.form = {
        id: '',
        userId: '',
        phone: '',
        createDate: '',
        updateDate: ''
      }
      this.openState = false
      this.formLoading = false
    },
    openPopup () {
      this.openState = true
    },
    openForm (id) {
      let _this = this
      _this.openState = true
      _this.formLoading = true
      this.$axios.post('/app/user/form', {id: id})
        .then((res) => {
          if (res.status === 200) {
            _this.form = res.data
            _this.isLoading = false
            _this.formLoading = false
          } else {
            _this.$message.error(res.msg)
          }
        })
    },
    // 用户列表
    listData () {
      let _this = this
      this.isLoading = true
      _this.list = []
      let option = _this.searchForm
      this.$axios.post('/user/invoice/list', option)
        .then((res) => {
          _this.list = res.data.rows
          _this.total = res.data.total
          _this.isLoading = false
        })
    }
  },
  mounted () {
    this.listData()
  }
}
</script>

<style scoped src="../../assets/css/user.css"></style>



// WEBPACK FOOTER //
// src/components/user/UserInvoice.vue